module.exports = __webpack_public_path__ + "static/img/sex_abuse.06ee231b.png";